import {Vue} from 'ui.vue';
import Modal from '../../../common/modal/src/modal';
import BasicInput from '../../../common/basic-input/src/basic-input';
import TextArea from '../../../common/text-area/src/text-area';
import {validation} from '../../../helpers/input-validation';
import './main.sass';

Vue.component('page-footer', {
	data() {
		return {
			showFeedbackModal: false,
			feedbackRequestParams: {
				firstName: {
					type: 'name',
					value: '',
					error: '',
				},
				lastName: {
					type: 'lastName',
					value: '',
					error: '',
				},
				email: {
					type: 'email',
					value: '',
					error: '',
				},
				phone: {
					type: 'phone',
					value: '',
					error: '',
				},
				question: {
					type: 'requiredLong',
					value: '',
					error: '',
				},
			},
		};
	},

	template: `
		<footer class="footer">
			<div class="footer-content--top">
				<div class="footer-content__col">
					<svg class="footer-logo" viewBox="0 0 46 48" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path d="M8.07482 31.9114h-2.0387v-7.9442H3.34546v-1.6949h7.43384v1.6949H8.07482v7.9442zM18.2944 30.2024v1.709H11.939v-9.6391h6.248v1.6949h-4.2093v2.3318h3.743v1.6809h-3.743v2.2225h4.3167zM19.606 28.2639v-2.3411c-.006-.5264.0569-1.0512.1871-1.5607.0818-.3027.2169-.5877.3989-.8413.453-.6034 1.1147-1.0097 1.985-1.2189.5268-.1031 1.062-.1553 1.5984-.1561.9257-.0017 1.8497.0798 2.7612.2435v1.6544c-.9126-.1508-1.8367-.2187-2.7612-.2029-.7158 0-1.2487.1738-1.5984.5213-.3498.3475-.5272.9146-.5323 1.7012v2.196c-.0092.7512.1529 1.2844.4863 1.5997.3334.3153.8815.4714 1.6444.4682.9241.0166 1.8478-.0471 2.7612-.1904v1.6669c-.9119.1594-1.8359.2367-2.7612.231-.5364-.0007-1.0716-.053-1.5984-.1561-.8693-.2081-1.531-.6144-1.985-1.2189-.182-.2535-.3171-.5386-.3989-.8413-.1302-.5095-.1931-1.0343-.1871-1.5607M34.4016 30.2024v1.709h-6.3555v-9.6391h6.2496v1.6949h-4.2109v2.3318h3.7446v1.6809h-3.7446v2.2225h4.3168zM3.4989 40.8326v-2.3411c-.00506-.5263.05786-1.0511.18715-1.5607.08206-.3021.21719-.5866.39884-.8397.54151-.7242.61361-.8928 1.98502-1.219.52679-.1031 1.06198-.1553 1.59844-.156.92566-.0017 1.84965.0797 2.76125.2434v1.6544c-.9127-.1508-1.83675-.2187-2.76125-.2029-.71588 0-1.24869.1738-1.59844.5213-.34976.3475-.52719.9146-.53231 1.7012v2.196c-.0092.7512.15289 1.2845.48629 1.5997.33339.3153.88154.4714 1.64446.4683.92405.0166 1.84782-.0471 2.76125-.1905v1.6544c-.91207.1587-1.83599.236-2.76125.231-.53646-.0007-1.07165-.053-1.59844-.1561-.8703-.2081-1.53197-.6149-1.98502-1.2205-.18224-.2527-.31742-.5373-.39884-.8396-.12948-.5097-.1924-1.0344-.18715-1.5608M17.8404 44.4785h-5.9029v-9.6376h2.0387v7.9301h3.8642v1.7075zM24.4826 34.8409h2.0387v6.0151c0 1.3755-.271 2.3427-.813 2.9014-.542.5588-1.4926.8402-2.8518.8444h-.1058c-1.4041 0-2.3634-.2893-2.8778-.8678-.5144-.5785-.7767-1.5378-.787-2.878v-6.0151h2.0387v6.0151c0 .7419.1202 1.2684.3605 1.5795.2404.3111.6622.4672 1.2656.4682h.1058c.6044 0 1.0263-.1514 1.2656-.4542.2393-.3028.3595-.8339.3605-1.5935v-6.0151zM32.0944 44.4785H28.106v-9.6376h3.7966c.5688-.0213 1.137.0568 1.6798.231.3864.1327.7095.4085.9051.7726.2045.3704.316.8989.3344 1.5857v.2434c.008.3757-.0917.7455-.2869 1.0645-.1863.2988-.4655.5257-.7931.6446v.0265c.4272.1174.8046.3747 1.0738.732.2657.3639.404.8079.3927 1.2611v.4198c-.0071.8678-.2469 1.5321-.7194 1.9931-.21.1897-.4537.337-.7179.4338-.5468.1682-1.1165.2457-1.6874.2295h.0107zm-.1979-7.9426h-1.7472v2.2084h1.7579c.5789 0 .8678-.3387.8668-1.016v-.2029c0-.6597-.2889-.9895-.8668-.9895h-.0107zm-1.7472 3.7957v2.4394h1.9451c.675 0 1.0329-.3641 1.0738-1.0925v-.2591c0-.4869-.1289-.7939-.3866-.9208-.2298-.1073-.4804-.1606-.7332-.1561l-1.8991-.0109z" fill="#060D35"/><path d="M42.6545 44.5253h-5.5224v-2.224h3.4776V14.1002L27.385 5.71126 13.9915 14.1393v5.5968h-2.0556V13.387c.0009-.1253.033-.2483.0934-.3575.0603-.1092.147-.201.2518-.2668l14.7265-9.25677c.1173-.06627.2493-.10105.3835-.10105s.2662.03478.3835.10105l14.5348 9.21927c.1039.0665.1897.1586.2495.2677.0598.1091.0916.2317.0926.3566l.003 31.1758z"/>
					</svg>
					<div class="footer__feedback footer__feedback--mobile">
						<a href="javascript:void(0)" @click="switchFeedbackModalVisibility(true)">Обратная связь</a>
					</div>
				</div>
				<div class="footer-content__col footer__social-icons">
					<a href="https://vk.com/tece_club" target="_blank">
						<img src="/local/templates/tece/img/logo-vk.svg" alt="vk">
					</a>
					<a href="https://www.youtube.com/channel/UC1tfYhRVIqRO8IViTcQvIgA/" target="_blank">
						<img src="/local/templates/tece/img/logo-youtube.svg" alt="youtube">
					</a>
				</div>
				<div class="footer-content__col footer__feedback">
					<a href="javascript:void(0)" @click="switchFeedbackModalVisibility(true)">Обратная связь</a>
				</div>
			</div>
			<div class="footer-content--bottom">
				<div class="footer__copyright">
					©&nbsp;ТЕСЕ&nbsp;{{ thisYear }}
				</div>
				<div id="politika">
					<a href="/privacy">Политика конфиденциальности</a>
				</div>
			</div>

			<Modal class="feedback-modal" v-if="showFeedbackModal" @close="switchFeedbackModalVisibility(false)">
				<template v-slot:body>
					<form class="feedback-form" @submit.prevent>
						<p class="feedback-form__header">Форма обратной связи</p>
						<div class="feedback-form__inputs-wrapper">
							<BasicInput
								class="feedback-form__input"
								title="Имя"
								v-model="feedbackRequestParams.firstName.value"
								:manualError="feedbackRequestParams.firstName.error"
							/>
							<BasicInput
								class="feedback-form__input"
								title="Фамилия"
								v-model="feedbackRequestParams.lastName.value"
								:manualError="feedbackRequestParams.lastName.error"
							/>
							<BasicInput
								class="feedback-form__input"
								title="E-mail"
								v-model="feedbackRequestParams.email.value"
								:manualError="feedbackRequestParams.email.error"
							/>
							<BasicInput
								class="feedback-form__input"
								title="Телефон"
								v-model="feedbackRequestParams.phone.value"
								:manualError="feedbackRequestParams.phone.error"
							/>
							<TextArea
								:class="['feedback-form__input--textarea', {'feedback-form__input--error': feedbackRequestParams.firstName.error}]"
								title="Ваш вопрос"
								v-model="feedbackRequestParams.question.value"
							/>
						</div>
						<div class="btn-wrapper">
							<button class="btn fullwidth" type="submit" @click="onSubmit">Отправить</button>
						</div>
					</form>
				</template>
			</Modal>
		</footer>
	`,

	components: {
		Modal,
		BasicInput,
		TextArea,
	},

	computed: {
		isFeedbackValidationError() {
			return Object.values(this.feedbackRequestParams).some(item => !!item.error);
		},
		thisYear() {
			return new Date().getFullYear();
		}
	},

	methods: {
		switchFeedbackModalVisibility(val) {
			this.showFeedbackModal = val;
		},
		validateForm() {
			Object.values(this.feedbackRequestParams).forEach(field => {
				field.error = validation(field);
			});
		},
		async onSubmit() {
			await this.validateForm();

			if (!this.isFeedbackValidationError) {
				const params = Object.entries(this.feedbackRequestParams).reduce((result, item) => {
					result[item[0]] = item[1].value;

					return result;
				}, {});
				const captcha_action = 'feedback_form';
									
				if (window.grecaptcha) {
					await window.grecaptcha.execute(window.RECAPTCHA_PUBLIC, {action: captcha_action})
						.then(function(token) {
							params.token = token;
							params.action = captcha_action;
						});
				}

				await Axios.post('/local/templates/tece/source/ajax/sender.php', params)
					.then(() => {
						this.feedbackRequestParams.firstName.value = '';
						this.feedbackRequestParams.lastName.value = '';
						this.feedbackRequestParams.email.value = '';
						this.feedbackRequestParams.phone.value = '';
						this.feedbackRequestParams.question.value = '';
						this.switchFeedbackModalVisibility(false);
					})
					.catch((err) => {
						console.error(err);
						this.switchFeedbackModalVisibility(false);
					});
			}
		},
	},
});

import { BitrixVue } from 'ui.vue';
import Axios from 'axios';

const app = BitrixVue.createApp({
	template: '<page-footer/>'
});
app.mount('PageFooter');